import { RELEASE, LOCAL } from '../constants/FJEvnConstant';
import FJAppConfigManager from '../common/js/FJAppConfigManager.js';
import FJVersionConfig from './FJVersionConfig.js';
import FJAppConstant from '../constants/FJAppConstant.js';
const environment = import.meta.env.MODE; // 当前环境
const currentFrom = import.meta.env.VITE_FROM; // 当前项目
const VERSION_CONFIG = {
    aiVideoGeneratorLandingPageVersion: '1.0.4.4.12',
    editVersion: '1.0.4.5.6',
    version: '1.0.4.5.6',
    codecResourceVersion: '1.0.4', // code 路径的版本
    wasmResourceVersion: '1.0.4', // wasm 资源路径的版本
    workVersion: '1.0.2', // 解码 mask 的版本
    textToSpeechVoicesVersion: '1.0.0', // 文字转语音的版本
    aiCommunityVersion: '1.0.0', // AI社区的版本
};

FJAppConfigManager.init();
// AI视频生成器着陆页
const isAiVideoGeneratorLandingPage = currentFrom === 'ai_video_generator_landing_page';
window.isAiVideoGeneratorLandingPage = isAiVideoGeneratorLandingPage;
const appType = isAiVideoGeneratorLandingPage
    ? FJAppConstant.AI_VIDEO_GENERATOR
    : window.isEditPage
      ? window.aiToolName
      : FJAppConfigManager.getDefaultType();

const FJConfig = {
    appType: appType,
    version: VERSION_CONFIG.version,
    // TODO AI工具整体改动的时候，需要修改这个路径
    webSocketUrl:
        environment === LOCAL
            ? 'https://www.smartvideomaker.com/'
            : environment !== RELEASE
              ? 'https://www.smartvideomaker.com/'
              : 'https://app.flexclip.com/',
    serverPath:
        environment === LOCAL
            ? 'http://localhost:3100/'
            : environment !== RELEASE
              ? 'https://www.smartvideomaker.com/'
              : 'https://www.flexclip.com/',
    requestPath:
        environment === LOCAL
            ? 'https://www.smartvideomaker.com'
            : environment !== RELEASE
              ? 'https://www.smartvideomaker.com'
              : 'https://www.flexclip.com',
    libPath: environment === LOCAL ? `/public/lib/` : `/app/ai-tools/lib/`,
    languagePath: environment === LOCAL ? `/language/local.` : `/app/ai-tools/language/local.`,
    staticResourceServe: environment === RELEASE ? 'https://resource.flexclip.com/' : `/`,
    imgPath: environment === LOCAL ? `/public/img/` : `/app/ai-tools/img/`,
    resourcePath: environment === LOCAL ? `/public/resource/` : `/app/ai-tools/resource/`,
    codecVersion: VERSION_CONFIG.codecResourceVersion,
    wasmVersion: VERSION_CONFIG.wasmResourceVersion,
    workVersion: VERSION_CONFIG.workVersion,
    textToSpeechVoicesVersion: VERSION_CONFIG.textToSpeechVoicesVersion,

    // TODO AI工具整体改动的时候，需要修改这个路径
    decodeMaskDataWorkPath:
        environment === LOCAL
            ? '/lib/work/decodeMaskDataWork.js'
            : environment !== RELEASE
              ? '/app/ai-tools/lib/work/decodeMaskDataWork.js'
              : '/app/ai-tools/lib/work/decodeMaskDataWork.js',
    addPointImage: environment === LOCAL ? '/public/img/add-point.svg' : '/app/ai-tools/img/add-point.svg',
    removePointImage: environment === LOCAL ? '/public/img/remove-point.svg' : '/app/ai-tools/img/remove-point.svg',
    selectedPointImage: environment === LOCAL ? '/public/img/select.svg' : '/app/ai-tools/img/select.svg',

    usePhotoTextToImageHistoryNullPng:
        environment === LOCAL ? '/public/img/text-to-image-null.png' : '/app/ai-tools/img/text-to-image-null.png',
    usePhotoImageToImageHistoryNullPng:
        environment === LOCAL ? '/public/img/img-to-image-null.png' : '/app/ai-tools/img/img-to-image-null.png',
    usePhotoImageToVideoHistoryNullPng:
        environment === LOCAL ? '/public/img/image-to-video-null.png' : '/app/ai-tools/img/image-to-video-null.png',
    usePhotoTextToVideoHistoryNullPng:
        environment === LOCAL ? '/public/img/text-to-video-null.png' : '/app/ai-tools/img/text-to-video-null.png',
    strokeImageBaseUrl: environment === LOCAL ? '/public/img/stroke/' : '/app/ai-tools/img/stroke/',
    eyedropperSupportBrowser: ['Chrome', 'Edge', 'Opera'], // 取色器浏览器支持
    notSupportBrowserImage:
        environment === LOCAL ? '/public/img/google-thumbnail.png' : '/app/ai-tools/img/google-thumbnail.png',
    produceAudioWorkerPath:
        environment === LOCAL
            ? `/public/lib/audioWorker/produceAudio.js?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/lib/audioWorker/produceAudio.js?v=${FJVersionConfig.staticPathVersion}`,
    giftPng: environment === LOCAL ? '/public/img/gift-icon.png' : '/app/ai-tools/img/gift-icon.png',
    videoThumbnailWorkerPath:
        environment === LOCAL
            ? `/public/lib/work/thumbnail/2.0.18/videoThumbnailWorker.js`
            : `/app/ai-tools/lib/work/thumbnail/2.0.18/videoThumbnailWorker.min.js`,

    supportAudioFormats: [
        'mp3',
        'wma',
        'aac',
        'wav',
        'm4a',
        'aiff',
        'mid',
        'amr',
        'au',
        'oga',
        'weba',
        'ogg',
        'opus',
        'flac',
    ],

    FLEXCLIP_PRODUCTION_URL: 'https://www.flexclip.com/',
    FLEXCLIP_PRODUCTION_URL_AI: 'https://www.flexclip.com/ai',
    isTest: environment !== RELEASE,
    isRelease: environment === RELEASE,
};
FJAppConfigManager.mergeConfig(FJConfig, appType);
//#endregion
console.log(
    window.isEditPage ? 'editVersion:::' : 'version:::',
    window.isEditPage ? VERSION_CONFIG.editVersion : VERSION_CONFIG.version,
    appType,
);
// window.isEditPage = true;
export default FJConfig;
